import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { ManageProductTagsRootParamList } from "../../../../types";
import { ManageProductTagsScreen } from "../ManageProductTagsScreen";
import { AddProductTagScreen } from "../AddProductTagScreen";

export type ManageProductTagsRootScreenProps = StackScreenProps<
  any,
  "ManageProductTagsRootScreen"
>;

export const ManageProductTagsRootScreen =
  ({}: ManageProductTagsRootScreenProps) => {
    const RootNavigator =
      createStackHeaderNavigator<ManageProductTagsRootParamList>();

    return (
      <RootNavigator.Navigator
        screenOptions={{
          headerShown: true,
          title: "",
          headerLeft: () => <ModalCloseButton type="Back" />,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <RootNavigator.Group>
          <RootNavigator.Screen
            name="ManageProductTagsScreen"
            component={ManageProductTagsScreen}
          />
        </RootNavigator.Group>
        <RootNavigator.Group
          screenOptions={{
            headerLeft: () => <ModalCloseButton type="Cancel" />,
          }}
        >
          <RootNavigator.Screen
            name="AddProductTagScreen"
            component={AddProductTagScreen}
          />
        </RootNavigator.Group>
      </RootNavigator.Navigator>
    );
  };
